import * as i0 from '@angular/core';
import { Injectable, Pipe, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, signal } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DotIncludesPipe, DotIsArrayPipe } from '@ng-dot/core';
import * as i2 from '@ng-dot/form/input';
import { DotInputModule } from '@ng-dot/form/input';
import { DotOfDefinePipe } from '@ng-dot/text';
import * as i5 from '@ng-dot/ui/icon';
import { DotIconModule } from '@ng-dot/ui/icon';
import * as i4 from '@ng-dot/ui/link';
import { DotLinkModule } from '@ng-dot/ui/link';
import { dateFormat } from '@js-dot/core/date';
import * as i1$1 from '@ng-dot/ui';
import { DotSelfUiService } from '@ng-dot/ui';
const _c0 = a0 => ({
  $implicit: a0
});
const _c1 = () => ["select", "date"];
function DotListFilterComponent_Conditional_0_Case_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "dot-label", 3);
  }
  if (rf & 2) {
    i0.ɵɵproperty("textContent", ctx);
  }
}
function DotListFilterComponent_Conditional_0_Case_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", ctx, i0.ɵɵsanitizeHtml);
  }
}
function DotListFilterComponent_Conditional_0_Case_0_Conditional_7_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "option", 9);
  }
  if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("value", option_r3.value)("innerHTML", option_r3.text, i0.ɵɵsanitizeHtml)("selected", ctx_r1.list._listKeywords$()[ctx_r1.adjust.filter["target"]] === option_r3.value);
  }
}
function DotListFilterComponent_Conditional_0_Case_0_Conditional_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, DotListFilterComponent_Conditional_0_Case_0_Conditional_7_Conditional_0_For_1_Template, 1, 3, "option", 9, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const options_r4 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(options_r4);
  }
}
function DotListFilterComponent_Conditional_0_Case_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotListFilterComponent_Conditional_0_Case_0_Conditional_7_Conditional_0_Template, 2, 0);
    i0.ɵɵpipe(1, "isArray");
  }
  if (rf & 2) {
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx) ? 0 : -1);
  }
}
function DotListFilterComponent_Conditional_0_Case_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", ctx, i0.ɵɵsanitizeHtml);
  }
}
function DotListFilterComponent_Conditional_0_Case_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotListFilterComponent_Conditional_0_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dot-inputs")(1, "label", 2);
    i0.ɵɵtemplate(2, DotListFilterComponent_Conditional_0_Case_0_Conditional_2_Template, 1, 1, "dot-label", 3)(3, DotListFilterComponent_Conditional_0_Case_0_Conditional_3_Template, 1, 1, "span", 4);
    i0.ɵɵelementStart(4, "select", 5);
    i0.ɵɵlistener("change", function DotListFilterComponent_Conditional_0_Case_0_Template_select_change_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.listFilterOnChange($event, ctx_r1.adjust));
    });
    i0.ɵɵelement(5, "option", 6);
    i0.ɵɵpipe(6, "ofDefine");
    i0.ɵɵtemplate(7, DotListFilterComponent_Conditional_0_Case_0_Conditional_7_Template, 2, 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, DotListFilterComponent_Conditional_0_Case_0_Conditional_8_Template, 1, 1, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, DotListFilterComponent_Conditional_0_Case_0_ng_container_9_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    let tmp_5_0;
    let tmp_7_0;
    let tmp_8_0;
    const filter_r5 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext();
    const displayFilterActions_r6 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_4_0 = ctx_r1.adjust.filter["label"]) ? 2 : -1, tmp_4_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_5_0 = ctx_r1.adjust.filter["prefix"]) ? 3 : -1, tmp_5_0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(6, 6, "LIST_FILTER_SELECT_PLACEHOLDER"), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_7_0 = filter_r5["options"]) ? 7 : -1, tmp_7_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_8_0 = ctx_r1.adjust.filter["suffix"]) ? 8 : -1, tmp_8_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", displayFilterActions_r6);
  }
}
function DotListFilterComponent_Conditional_0_Case_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
  if (rf & 2) {
    i0.ɵɵproperty("textContent", ctx);
  }
}
function DotListFilterComponent_Conditional_0_Case_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", ctx, i0.ɵɵsanitizeHtml);
  }
}
function DotListFilterComponent_Conditional_0_Case_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", ctx, i0.ɵɵsanitizeHtml);
  }
}
function DotListFilterComponent_Conditional_0_Case_1_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotListFilterComponent_Conditional_0_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dot-inputs")(1, "label", 2);
    i0.ɵɵtemplate(2, DotListFilterComponent_Conditional_0_Case_1_Conditional_2_Template, 1, 1, "span", 10)(3, DotListFilterComponent_Conditional_0_Case_1_Conditional_3_Template, 1, 1, "span", 4);
    i0.ɵɵelementStart(4, "input", 11, 1);
    i0.ɵɵpipe(6, "listFilterKeyword");
    i0.ɵɵlistener("keyup", function DotListFilterComponent_Conditional_0_Case_1_Template_input_keyup_4_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.list.listOnFilterKeyUp($event, ctx_r1.adjust));
    })("change", function DotListFilterComponent_Conditional_0_Case_1_Template_input_change_4_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.listFilterOnChange($event, ctx_r1.adjust));
    })("focus", function DotListFilterComponent_Conditional_0_Case_1_Template_input_focus_4_listener() {
      i0.ɵɵrestoreView(_r7);
      const input_r8 = i0.ɵɵreference(5);
      return i0.ɵɵresetView(input_r8.showPicker());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, DotListFilterComponent_Conditional_0_Case_1_Conditional_7_Template, 1, 1, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, DotListFilterComponent_Conditional_0_Case_1_ng_container_8_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    let tmp_9_0;
    const input_r8 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext(2);
    const displayFilterActions_r6 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_5_0 = ctx_r1.adjust.filter["label"]) ? 2 : -1, tmp_5_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_6_0 = ctx_r1.adjust.filter["prefix"]) ? 3 : -1, tmp_6_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.adjust.filter["type"])("ngModel", i0.ɵɵpipeBind1(6, 7, ctx_r1.list._listKeywords$()[ctx_r1.adjust.filter["target"]]));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional((tmp_9_0 = ctx_r1.adjust.filter["suffix"]) ? 7 : -1, tmp_9_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", displayFilterActions_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c0, input_r8));
  }
}
function DotListFilterComponent_Conditional_0_Case_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
  }
  if (rf & 2) {
    i0.ɵɵproperty("textContent", ctx);
  }
}
function DotListFilterComponent_Conditional_0_Case_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", ctx, i0.ɵɵsanitizeHtml);
  }
}
function DotListFilterComponent_Conditional_0_Case_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("innerHTML", ctx, i0.ɵɵsanitizeHtml);
  }
}
function DotListFilterComponent_Conditional_0_Case_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function DotListFilterComponent_Conditional_0_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "dot-inputs")(1, "label", 2);
    i0.ɵɵtemplate(2, DotListFilterComponent_Conditional_0_Case_2_Conditional_2_Template, 1, 1, "span", 10)(3, DotListFilterComponent_Conditional_0_Case_2_Conditional_3_Template, 1, 1, "span", 4);
    i0.ɵɵelementStart(4, "input", 13, 1);
    i0.ɵɵlistener("keyup", function DotListFilterComponent_Conditional_0_Case_2_Template_input_keyup_4_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.list.listOnFilterKeyUp($event, ctx_r1.adjust));
    })("change", function DotListFilterComponent_Conditional_0_Case_2_Template_input_change_4_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.listFilterOnChange($event, ctx_r1.adjust));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, DotListFilterComponent_Conditional_0_Case_2_Conditional_6_Template, 1, 1, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, DotListFilterComponent_Conditional_0_Case_2_ng_container_7_Template, 1, 0, "ng-container", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    let tmp_9_0;
    const input_r10 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext(2);
    const displayFilterActions_r6 = i0.ɵɵreference(2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_5_0 = ctx_r1.adjust.filter["label"]) ? 2 : -1, tmp_5_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_6_0 = ctx_r1.adjust.filter["prefix"]) ? 3 : -1, tmp_6_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.adjust.filter["type"])("ngModel", ctx_r1.list._listKeywords$()[ctx_r1.adjust.filter["target"]]);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_9_0 = ctx_r1.adjust.filter["suffix"]) ? 6 : -1, tmp_9_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", displayFilterActions_r6)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c0, input_r10));
  }
}
function DotListFilterComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotListFilterComponent_Conditional_0_Case_0_Template, 10, 8, "dot-inputs")(1, DotListFilterComponent_Conditional_0_Case_1_Template, 9, 11, "dot-inputs")(2, DotListFilterComponent_Conditional_0_Case_2_Template, 8, 9, "dot-inputs");
  }
  if (rf & 2) {
    let tmp_3_0;
    i0.ɵɵconditional((tmp_3_0 = ctx["type"]) === "select" ? 0 : tmp_3_0 === "date" ? 1 : 2);
  }
}
function DotListFilterComponent_ng_template_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵpipe(1, "icon");
    i0.ɵɵpipe(2, "ofDefine");
    i0.ɵɵlistener("click", function DotListFilterComponent_ng_template_1_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.list.listFilterCancel(ctx_r1.adjust));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 3, ctx_r1.list.configure.filterCancelIcon), i0.ɵɵsanitizeHtml)("tip", i0.ɵɵpipeBind1(2, 5, "LIST_FILTER_CANCEL"))("tipDelay", ctx_r1.list.tipDelay);
  }
}
function DotListFilterComponent_ng_template_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵpipe(1, "icon");
    i0.ɵɵpipe(2, "ofDefine");
    i0.ɵɵlistener("click", function DotListFilterComponent_ng_template_1_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.list.listFilterSubmit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 3, ctx_r1.list.configure.filterSubmitIcon), i0.ɵɵsanitizeHtml)("tip", i0.ɵɵpipeBind1(2, 5, "LIST_FILTER_SUBMIT"))("tipDelay", ctx_r1.list.tipDelay);
  }
}
function DotListFilterComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dot-input-actions");
    i0.ɵɵtemplate(1, DotListFilterComponent_ng_template_1_Conditional_1_Template, 3, 7, "button", 14)(2, DotListFilterComponent_ng_template_1_Conditional_2_Template, 3, 7, "button", 15);
    i0.ɵɵpipe(3, "includes");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.list._listKeywords$()[ctx_r1.adjust.filter["target"]] ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!i0.ɵɵpipeBind2(3, 2, i0.ɵɵpureFunction0(5, _c1), ctx_r1.adjust == null ? null : ctx_r1.adjust.filter["type"]) ? 2 : -1);
  }
}
const _c2 = ["*"];
function DotListFiltersComponent_Conditional_0_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "dot-input-area", 1);
    i0.ɵɵelement(1, "dot-list-filter", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const adjust_r1 = i0.ɵɵnextContext().$implicit;
    const link_r2 = i0.ɵɵnextContext();
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("shape", ctx_r2.shape);
    i0.ɵɵadvance();
    i0.ɵɵproperty("list", link_r2)("adjust", adjust_r1)("autoSubmit", false);
  }
}
function DotListFiltersComponent_Conditional_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DotListFiltersComponent_Conditional_0_For_1_Conditional_0_Template, 2, 4, "dot-input-area", 1);
  }
  if (rf & 2) {
    let tmp_12_0;
    const adjust_r1 = ctx.$implicit;
    i0.ɵɵconditional((tmp_12_0 = adjust_r1.filter) ? 0 : -1, tmp_12_0);
  }
}
function DotListFiltersComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵpipe(1, "ofDefine");
    i0.ɵɵpipe(2, "icon");
    i0.ɵɵpipe(3, "ofDefine");
    i0.ɵɵlistener("click", function DotListFiltersComponent_Conditional_0_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const link_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(link_r2.listFilterSubmit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 4, link_r2.configure.filterSubmitIcon, i0.ɵɵpipeBind1(1, 2, "LIST_FILTER_SUBMIT")), i0.ɵɵsanitizeHtml)("tip", i0.ɵɵpipeBind1(3, 7, "LIST_FILTER_SUBMIT"));
  }
}
function DotListFiltersComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, DotListFiltersComponent_Conditional_0_For_1_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵprojection(2);
    i0.ɵɵtemplate(3, DotListFiltersComponent_Conditional_0_Conditional_3_Template, 4, 9, "button", 0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx.listStableAdjusts$());
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r2.onlyOneSubmit ? 3 : -1);
  }
}
class DotListService {
  static ɵfac = function DotListService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListService)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DotListService,
    factory: DotListService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class DotListFilterKeywordPipe {
  transform(value) {
    if (value instanceof Date) {
      return dateFormat('Y-m-d', value);
    }
    return value;
  }
  static ɵfac = function DotListFilterKeywordPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListFilterKeywordPipe)();
  };
  static ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "listFilterKeyword",
    type: DotListFilterKeywordPipe,
    pure: true
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListFilterKeywordPipe, [{
    type: Pipe,
    args: [{
      standalone: true,
      name: 'listFilterKeyword'
    }]
  }], null, null);
})();
class DotListFilterComponent {
  list;
  adjust;
  autoSubmit = true;
  listFilterOnChange($event, adjust) {
    this.list.listFilterOnChange($event, adjust, this.autoSubmit);
  }
  static ɵfac = function DotListFilterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListFilterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListFilterComponent,
    selectors: [["dot-list-filter"]],
    inputs: {
      list: "list",
      adjust: "adjust",
      autoSubmit: "autoSubmit"
    },
    decls: 3,
    vars: 1,
    consts: [["displayFilterActions", ""], ["input", ""], ["dotInput", ""], [3, "textContent"], ["dotPrefix", "", 3, "innerHTML"], ["dotControl", "", 3, "change"], [3, "innerHTML"], ["dotSuffix", "", 3, "innerHTML"], [4, "ngTemplateOutlet"], [3, "value", "innerHTML", "selected"], ["dotLabel", "", 3, "textContent"], ["dotControl", "", 3, "keyup", "change", "focus", "type", "ngModel"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["dotControl", "", 3, "keyup", "change", "type", "ngModel"], ["dot-link", "", "type", "button", 1, "filter-link", "filter-link-cancel", 3, "innerHTML", "tip", "tipDelay"], ["dot-link", "", "type", "submit", 1, "filter-link", "filter-link-submit", 3, "innerHTML", "tip", "tipDelay"], ["dot-link", "", "type", "button", 1, "filter-link", "filter-link-cancel", 3, "click", "innerHTML", "tip", "tipDelay"], ["dot-link", "", "type", "submit", 1, "filter-link", "filter-link-submit", 3, "click", "innerHTML", "tip", "tipDelay"]],
    template: function DotListFilterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, DotListFilterComponent_Conditional_0_Template, 3, 1)(1, DotListFilterComponent_ng_template_1_Template, 4, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        let tmp_1_0;
        i0.ɵɵconditional((tmp_1_0 = ctx.adjust.filter) ? 0 : -1, tmp_1_0);
      }
    },
    dependencies: [CommonModule, i1.NgTemplateOutlet, DotInputModule, i2.DotInputControlDirective, i2.DotSelectControlDirective, i2.DotInputsComponent, i2.DotInputDirective, i2.DotInputActionsComponent, i2.DotLabelDirective, i2.DotLabelComponent, i2.DotSuffixDirective, i2.DotPrefixDirective, DotListFilterKeywordPipe, DotOfDefinePipe, FormsModule, i3.NgSelectOption, i3.ɵNgSelectMultipleOption, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, DotLinkModule, i4.DotLinkComponent, DotIconModule, i5.DotIconPipe, DotIncludesPipe, DotIsArrayPipe],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListFilterComponent, [{
    type: Component,
    args: [{
      selector: 'dot-list-filter',
      template: `
		@if (adjust.filter; as filter) {
			@switch (filter['type']) {
				@case ('select') {
					<dot-inputs>
						<label dotInput>
							@if (adjust.filter['label']; as value) {
								<dot-label
									[textContent]="value"></dot-label>
							}
							@if (adjust.filter['prefix']; as value) {
								<span dotPrefix
									  [innerHTML]="value"></span>
							}
							<select
								dotControl
								(change)="listFilterOnChange($event, adjust)"
							>
								<option [innerHTML]="'LIST_FILTER_SELECT_PLACEHOLDER' | ofDefine"></option>
								@if (filter['options']; as options) {
									@if (options | isArray) {
										@for (option of options; track option) {
											<option
												[value]="option.value"
												[innerHTML]="option.text"
												[selected]="list._listKeywords$()[adjust.filter['target']] === option.value"
											>
											</option>
										}
									}
								}
							</select>
							@if (adjust.filter['suffix']; as value) {
								<span dotSuffix
									  [innerHTML]="value"></span>
							}
						</label>
						<ng-container *ngTemplateOutlet="displayFilterActions"></ng-container>
					</dot-inputs>
				}
				@case ('date') {
					<dot-inputs>
						<label dotInput>
							@if (adjust.filter['label']; as label) {
								<span dotLabel
									  [textContent]="label"></span>
							}
							@if (adjust.filter['prefix']; as value) {
								<span dotPrefix
									  [innerHTML]="value"></span>
							}
							<input
								dotControl
								[type]="adjust.filter['type']"
								(keyup)="list.listOnFilterKeyUp($event, adjust)"
								(change)="listFilterOnChange($event, adjust)"
								(focus)="$any(input).showPicker()"
								[ngModel]="list._listKeywords$()[adjust.filter['target']] | listFilterKeyword"
								#input
							>
							@if (adjust.filter['suffix']; as value) {
								<span dotSuffix
									  [innerHTML]="value"></span>
							}
						</label>
						<ng-container
							*ngTemplateOutlet="displayFilterActions; context: {$implicit: input}"></ng-container>
					</dot-inputs>
				}
				@default {
					<dot-inputs>
						<label dotInput>
							@if (adjust.filter['label']; as label) {
								<span dotLabel
									  [textContent]="label"></span>
							}
							@if (adjust.filter['prefix']; as value) {
								<span dotPrefix
									  [innerHTML]="value"></span>
							}
							<input
								dotControl
								[type]="adjust.filter['type']"
								(keyup)="list.listOnFilterKeyUp($event, adjust)"
								(change)="listFilterOnChange($event, adjust)"
								[ngModel]="list._listKeywords$()[adjust.filter['target']]"
								#input
							>
							@if (adjust.filter['suffix']; as value) {
								<span dotSuffix
									  [innerHTML]="value"></span>
							}
						</label>
						<ng-container
							*ngTemplateOutlet="displayFilterActions; context: {$implicit: input}"/>
					</dot-inputs>
				}
			}
		}
		<ng-template #displayFilterActions let-input>
			<dot-input-actions>
				@if (list._listKeywords$()[adjust.filter['target']]) {
					<button
						dot-link
						type="button"
						class="filter-link filter-link-cancel"
						[innerHTML]="list.configure.filterCancelIcon | icon"
						[tip]="'LIST_FILTER_CANCEL' | ofDefine"
						[tipDelay]="list.tipDelay"
						(click)="list.listFilterCancel(adjust)"
					></button>
				}
				@if (!(['select', 'date'] | includes:adjust?.filter['type'])) {
					<button
						dot-link
						type="submit"
						class="filter-link filter-link-submit"
						[innerHTML]="list.configure.filterSubmitIcon | icon"
						[tip]="'LIST_FILTER_SUBMIT' | ofDefine"
						[tipDelay]="list.tipDelay"
						(click)="list.listFilterSubmit()"
					></button>
				}
			</dot-input-actions>
		</ng-template>
	`,
      imports: [CommonModule, DotInputModule, DotListFilterKeywordPipe, DotOfDefinePipe, FormsModule, DotLinkModule, DotIconModule, DotIncludesPipe, DotIsArrayPipe],
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush
    }]
  }], null, {
    list: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    adjust: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    autoSubmit: [{
      type: Input
    }]
  });
})();
class DotListFiltersComponent {
  _ui;
  /**
   * @see DotInputShape
   */
  shape = 'clear';
  /**
   * Hide all Submit buttons
   */
  noSubmit = false;
  /**
   * Show Only one submit button
   */
  onlyOneSubmit = false;
  remoteRef;
  // link$ = signal<DotListComponentBase>(null);
  link$ = signal(null);
  #remoteListRef;
  constructor(_ui) {
    this._ui = _ui;
  }
  ngAfterViewInit() {
    if (this.remoteRef) {
      this._ui.getRemoteRef$(this.remoteRef).subscribe(ref => {
        this.#remoteListRef = ref;
        this.link$.set(ref);
        if (ref) {
          ref['outerFilter'] = true;
        }
      });
    }
  }
  ngOnDestroy() {
    if (this.#remoteListRef) {
      this.#remoteListRef.outerFilter = false;
    }
  }
  static ɵfac = function DotListFiltersComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotListFiltersComponent)(i0.ɵɵdirectiveInject(i1$1.DotSelfUiService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotListFiltersComponent,
    selectors: [["dot-list-filters"]],
    hostAttrs: [1, "dot-list-filters"],
    hostVars: 4,
    hostBindings: function DotListFiltersComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("_no-submit", ctx.noSubmit)("_only-one-submit", ctx.onlyOneSubmit);
      }
    },
    inputs: {
      shape: "shape",
      noSubmit: "noSubmit",
      onlyOneSubmit: "onlyOneSubmit",
      remoteRef: "remoteRef"
    },
    features: [i0.ɵɵProvidersFeature([DotSelfUiService])],
    ngContentSelectors: _c2,
    decls: 1,
    vars: 1,
    consts: [["dot-link", "", 3, "innerHTML", "tip"], [3, "shape"], [3, "list", "adjust", "autoSubmit"], ["dot-link", "", 3, "click", "innerHTML", "tip"]],
    template: function DotListFiltersComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, DotListFiltersComponent_Conditional_0_Template, 4, 1);
      }
      if (rf & 2) {
        let tmp_0_0;
        i0.ɵɵconditional((tmp_0_0 = ctx.link$()) ? 0 : -1, tmp_0_0);
      }
    },
    dependencies: [
    // DotListFilterKeywordPipe,
    // DotIncludesPipe,
    ReactiveFormsModule, DotOfDefinePipe, DotInputModule, i2.DotInputAreaComponent, FormsModule, DotLinkModule, i4.DotLinkComponent, DotIconModule, i5.DotIconPipe, DotListFilterComponent],
    styles: [":root{--list-filters-gap: 16px}.dot-list-filters{display:flex;gap:var(--list-filters-gap)}.dot-list-filters._no-submit .filter-link-submit,.dot-list-filters._only-one-submit .filter-link-submit{display:none}\n"],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotListFiltersComponent, [{
    type: Component,
    args: [{
      imports: [
      // DotListFilterKeywordPipe,
      // DotIncludesPipe,
      ReactiveFormsModule, DotOfDefinePipe, DotInputModule, FormsModule, DotLinkModule, DotIconModule, DotOfDefinePipe, DotInputModule, DotListFilterComponent],
      providers: [DotSelfUiService],
      selector: 'dot-list-filters',
      template: `
		@if (link$(); as link) {
		  @for (adjust of link.listStableAdjusts$(); track adjust) {
		    @if (adjust.filter; as filter) {
		      <dot-input-area [shape]="shape">
		        <dot-list-filter [list]="link" [adjust]="adjust" [autoSubmit]="false"></dot-list-filter>
		      </dot-input-area>
		    }
		  }
		  <ng-content></ng-content>
		  @if (onlyOneSubmit) {
		    <button dot-link
		      [innerHTML]="link.configure.filterSubmitIcon | icon: ('LIST_FILTER_SUBMIT' | ofDefine)"
		      [tip]="'LIST_FILTER_SUBMIT' | ofDefine"
		      (click)="link.listFilterSubmit()"
		    ></button>
		  }
		}
		`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.Default,
      host: {
        class: 'dot-list-filters',
        '[class._no-submit]': 'noSubmit',
        '[class._only-one-submit]': 'onlyOneSubmit'
      },
      styles: [":root{--list-filters-gap: 16px}.dot-list-filters{display:flex;gap:var(--list-filters-gap)}.dot-list-filters._no-submit .filter-link-submit,.dot-list-filters._only-one-submit .filter-link-submit{display:none}\n"]
    }]
  }], () => [{
    type: i1$1.DotSelfUiService
  }], {
    shape: [{
      type: Input
    }],
    noSubmit: [{
      type: Input
    }],
    onlyOneSubmit: [{
      type: Input
    }],
    remoteRef: [{
      type: Input
    }]
  });
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotListFilterComponent, DotListFilterKeywordPipe, DotListFiltersComponent, DotListService };
